import { render, staticRenderFns } from "./AgendaItem.vue?vue&type=template&id=59e43f1b&"
import script from "./AgendaItem.vue?vue&type=script&lang=js&"
export * from "./AgendaItem.vue?vue&type=script&lang=js&"
import style0 from "./AgendaItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59e43f1b')) {
      api.createRecord('59e43f1b', component.options)
    } else {
      api.reload('59e43f1b', component.options)
    }
    module.hot.accept("./AgendaItem.vue?vue&type=template&id=59e43f1b&", function () {
      api.rerender('59e43f1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/AgendaItem.vue"
export default component.exports